<script lang="ts">
	import { ControlsContainer, SidepanelContent, Text } from '@Shelly/shelly-design-system';
	import ControlAlarm from 'src/components/Lists/Alarms/ControlAlarm.svelte';
	import TimerAlarmDelay from 'src/components/Lists/Alarms/components/TimerAlarmDelay.svelte';
	import { alarms } from 'src/stores/lists/scenes-derived';

	export let id;
	export let alarm;
	export let isAlarmEnabled;
	export let textUnderDeviceButtonTranslation;

	let showDelayModal = false;
</script>

<SidepanelContent>
	<div slot="staticBottom">
		<ControlsContainer color="color-0">
			<div slot="first">
				<ControlAlarm
					item={$alarms[id]}
					isOnDrawer
					on:alarmDelayStart={(e) => {
						showDelayModal = true;
					}}
				/>

				<TimerAlarmDelay alarm={$alarms[id]} hideLabel bind:showModal={showDelayModal} />

				<Text styleType="controls-large" class="mt-s text-bold">
					{textUnderDeviceButtonTranslation}
				</Text>
			</div>
		</ControlsContainer>
	</div>
</SidepanelContent>
